import axiosInstance from "../../../features/api/axiosInstance";
const base_url = process.env.REACT_APP_API_URL;

const API_URL = `${base_url}user/create-applications`;


// ✅ Create new loan step
const createApplication = async (data) => {

  const response = await axiosInstance.post(API_URL, data);
  return response.data;
};



const applicationService = {
    createApplication,
};

export default applicationService;
